/* jshint esversion: 6 */
import React from 'react';
import SocialPanelModule from 'app/mixins/SocialPanelModule.js';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import Toggle from 'app/components/common/ToggleControl.jsx';
import StyledSelect from 'app/components/common/StyledSelect.jsx';

class YouTubeOptions extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            categoriesLoaded: false
        };

    }

    componentDidMount() {
        this.props.getYouTubeCategories(this.props.router.params.socialId);
        this.props.getYouTubePlaylists(this.props.router.params.socialId);
    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps && prevProps.app.loading.SOCIAL_GET_CATEGORIES === true && this.props.app.loading.SOCIAL_GET_CATEGORIES === false) {
            this.setState({
                categoriesLoaded: true
            });
        }
    }

    render() {
        let currentPanel = null,
            constants = this.props.app.config.constants;

        if (this.props.activePanel !== 'advanced') {
            currentPanel = (
                <div>
                    {this.props.getYouTubeFields(this.props.socials.categories, this.props.socials.playlists)}
                    {this.props.getActiveToggle()}
                    {this.props.getDeleteButton()}
                </div>
            );
        }

        return this.props.getPanelOutput(currentPanel);
    }

};

export default SocialPanelModule(YouTubeOptions);
